import { createFileRoute } from '@tanstack/react-router'
import { TemplatesListPage } from '@/features/scheduler/templates/templates-list-page'

export const Route = createFileRoute(
  '/_authenticated/_organization/scheduler/templates/'
)({
  component: TemplatesListPage,
})
